import { Dayjs } from "dayjs";
import { ZUid } from "src/types/zUid";
import { z } from "zod";

export const zAuditEvent = z.object({
  userId: z.string(),
  timestamp: z.string(), // "2025-04-28T15:04:38.681Z",
  fio: z.string(),
  // "email": "string",
  transactionId: z.string(),
});
export type ZAuditEvent = z.infer<typeof zAuditEvent>;

export const zPageAuditEvent = z.object({
  content: zAuditEvent.array(),
  pageToken: z.string().nullish(),
});
export type ZPageAuditEvent = z.infer<typeof zPageAuditEvent>;

export type AuditFilterUI = {
  range?: [Dayjs | undefined, Dayjs | undefined];
  userId?: string;
};

export type AuditFilterJson = {
  timestampFrom?: string;
  timestampTo?: string;
  userId?: string;
};

export type AuditSearchFilter = AuditFilterJson & {
  entityId: ZUid;
  pageSize: number;
  pageToken?: string;
};
